/* ==========================================================================
   EazyLife — petites corrections sur les composants NATIFS de Kalles.
   Aucun fichier de Kalles n'est modifié : on ne fait que rectifier, depuis
   l'extérieur, ce que son balisage annonce de travers.

   Chargé par `sections/ezl-footer.liquid` (la seule section présente sur
   toutes les pages), en `defer`.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     APERÇU — les deux fenêtres doivent TOUJOURS s'afficher.

     Kalles retient « déjà vue » dans un cookie (`theme4:newsletter:…`,
     `theme4:exit:…`) pendant 7 jours. Pratique pour un client, insupportable
     pour relire son propre thème : une fois fermée, la fenêtre disparaît
     pendant une semaine.

     Sur un thème NON PUBLIÉ (aperçu, brouillon) on efface donc cette mémoire
     à chaque chargement. Dès que le thème est publié — `Shopify.theme.role`
     passe à « main » — ce bloc ne fait plus rien et la mémoire de 7 jours
     reprend normalement pour les vrais visiteurs.

     Ce script est chargé SANS `defer`, depuis le pied de page : il s'exécute
     donc avant que les fenêtres (groupe « system ») ne soient analysées.
     ------------------------------------------------------------------------ */
  function memoireApercu() {
    try {
      var role = window.Shopify && Shopify.theme && Shopify.theme.role;
      if (!role || role === 'main') return;
      document.cookie.split(';').forEach(function (morceau) {
        var nom = morceau.split('=')[0].trim();
        if (nom.indexOf('theme4:newsletter:') === 0 || nom.indexOf('theme4:exit:') === 0) {
          document.cookie = nom + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        }
      });
    } catch (e) {}
  }

  memoireApercu();

  /* ------------------------------------------------------------------------
     FENÊTRE OFFRE (`exit-popup`) — netteté de la photo.

     Kalles écrit `sizes="(min-width:1150px) 26vw, ..."` parce que sa mise en
     page prévoit une colonne de produits à côté. Sans produits, l'image occupe
     TOUTE la largeur de la fenêtre (620 px) : le navigateur téléchargeait donc
     une version de ~330 px et l'agrandissait — photo floue.
     On corrige la valeur annoncée : le navigateur rechoisit tout seul la bonne
     définition dans le `srcset` déjà fourni par Kalles.
     ------------------------------------------------------------------------ */
  function nettete() {
    var images = document.querySelectorAll('.hdt-modal-exit picture img');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.dataset.ezlSizes === '1') continue;
      img.dataset.ezlSizes = '1';
      img.sizes = '(min-width: 768px) 620px, calc(100vw - 32px)';
    }
  }

  /* ------------------------------------------------------------------------
     ÉCHAP FERME LA FENÊTRE.

     Les fenêtres de Kalles s'ouvrent en mode « non modal » : la touche Échap
     n'a donc AUCUN effet — le visiteur appuie, rien ne bouge, et il croit la
     page bloquée. On rebranche Échap sur le bouton de fermeture de Kalles :
     c'est SA fermeture qui s'exécute (animation, mémoire, déblocage du
     défilement), on ne fait que l'appeler.
     ------------------------------------------------------------------------ */
  function echap() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var ouverte = document.querySelector(
        '.hdt-modal-newsletter dialog[open], .hdt-modal-exit dialog[open]'
      );
      if (!ouverte) return;
      var croix = ouverte.querySelector('.hdt-dialog-btn__close');
      if (croix) croix.click();
    });
  }

  /* ------------------------------------------------------------------------
     QUAND S'OUVRENT LES DEUX FENÊTRES.

     Kalles ne sait déclencher qu'« après N pixels » ou « tout en bas de la
     page ». Nous les voulons accrochées à deux MOMENTS de la page d'accueil,
     ce qui reste juste sur n'importe quelle taille d'écran :

       · newsletter  → quand les 6 photos du hero sont finies
       · promotions  → sur la grande image de fin « EazyLifeStore — La vie est
                       belle quand elle est bien choisie », juste avant de partir

     On garde le composant de Kalles : on se contente d'appeler son `open()`
     au bon moment. Sa fermeture, sa mémoire (cookie) et son animation restent
     les siennes — rien n'est remplacé.
     ------------------------------------------------------------------------ */
  function lu(cle) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().indexOf(cle + '=') === 0;
    });
  }

  function idSezione(balise) {
    var el = document.querySelector(balise);
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('configs')).id; } catch (e) { return null; }
  }

  /* jamais deux fenêtres l'une sur l'autre : on attend poliment */
  function ouvrirQuandLibre(modal) {
    if (document.querySelector('dialog[open]')) {
      setTimeout(function () { ouvrirQuandLibre(modal); }, 700);
      return;
    }
    try { modal.open(); } catch (e) {}
  }

  function declencheurs() {
    if (!document.body.classList.contains('hdt-page-type-index')) return;

    /* --- 1) NEWSLETTER : à la fin des 6 photos ---------------------------
       `ezl-home.js` pose la classe `ezl-hero-passed` sur <body> exactement à
       la fin du hero : c'est le signal le plus juste qui existe, il suit
       l'animation elle-même et pas un nombre de pixels. */
    var news = document.querySelector('.hdt-modal-newsletter');
    var sysNews = document.querySelector('sys-newsletter');
    var idNews = idSezione('sys-newsletter');

    if (news && sysNews && idNews && !lu('theme4:newsletter:' + idNews)) {
      /* On neutralise le déclencheur en pixels de Kalles (il tomberait au
         mauvais endroit sur un grand écran) en repoussant son seuil très loin.
         `showModalScroll` relit cette valeur à chaque fois : sa fermeture et sa
         mémoire, elles, continuent de fonctionner normalement. */
      try { if (sysNews.configs) sysNews.configs.scroll_delay = 1e9; } catch (e) {}

      var ouvre = function () {
        if (document.body.classList.contains('ezl-hero-passed')) {
          obsHero.disconnect();
          ouvrirQuandLibre(news);
          return true;
        }
        return false;
      };
      var obsHero = new MutationObserver(ouvre);
      obsHero.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      ouvre();   /* si le hero est déjà passé (rechargement en cours de page) */
    }

    /* --- 2) PROMOTIONS : sur la grande image de fin ----------------------
       `#prefoot` est la dernière section avant le pied de page : la photo
       « EazyLifeStore — La vie est belle quand elle est bien choisie ».
       C'est le dernier regard du visiteur avant de partir : le bon moment. */
    var promo = document.querySelector('.hdt-modal-exit');
    var idExit = idSezione('sys-exit');
    var securite = document.getElementById('prefoot');

    if (promo && idExit && securite && !lu('theme4:exit:' + idExit) && 'IntersectionObserver' in window) {
      var obsSec = new IntersectionObserver(function (entrees) {
        for (var i = 0; i < entrees.length; i++) {
          if (entrees[i].isIntersecting) {
            obsSec.disconnect();
            ouvrirQuandLibre(promo);
            return;
          }
        }
      }, { threshold: 0.15 });
      obsSec.observe(securite);
    }
  }

  /* ------------------------------------------------------------------------
     LOOKBOOK — les « + » sans produit n'ouvrent rien.

     Les points du lookbook sont faits pour ouvrir une fiche produit. Tant
     qu'aucun produit n'y est assigné, Kalles affiche à la place SA fiche de
     démonstration : « Titre produit exemple », un prix inventé, et deux liens
     vers /admin/products — l'administration de la boutique, exposée au client.

     On garde les « + » (ils font partie du design, et ils accueilleront les
     vrais produits), mais on neutralise UNIQUEMENT ceux dont la fiche est
     encore la démonstration de Kalles. Le repère est le lien vers /admin :
     dès qu'un vrai produit est assigné, il disparaît et le point refonctionne
     tout seul — rien à défaire plus tard.
     ------------------------------------------------------------------------ */
  function pointsLookbook() {
    var fiches = document.querySelectorAll('.hdt-lookbook_pin');
    for (var i = 0; i < fiches.length; i++) {
      var fiche = fiches[i];
      var estDemo = !!fiche.querySelector('a[href*="/admin/"]');
      var bouton = fiche.id
        ? document.querySelector('[aria-controls="' + fiche.id + '"]')
        : null;

      if (estDemo) {
        /* souris ET clavier : le point reste visible (c'est le design) mais
           n'ouvre rien, et la fiche de démonstration est verrouillée par le CSS. */
        fiche.setAttribute('hidden', '');
        if (bouton) {
          bouton.setAttribute('aria-disabled', 'true');
          bouton.setAttribute('tabindex', '-1');
        }
      } else {
        fiche.removeAttribute('hidden');
        if (bouton) {
          bouton.removeAttribute('aria-disabled');
          bouton.removeAttribute('tabindex');
        }
      }
    }
  }


  /* ------------------------------------------------------------------------
     BARRE LATÉRALE — « La sélection du moment » ne montre rien de faux.

     Tant que la collection « Promotions » est vide, Kalles affiche à la place
     TROIS fiches de démonstration : « Titre produit exemple — 19,99 dh ».
     Le CSS les masque déjà avec `:has(.hdt-placeholder-svg)`. Ceci est le
     filet pour les navigateurs qui ne connaissent pas encore `:has()` : on
     pose un attribut que le CSS masque aussi.

     Dès qu'un vrai produit entre dans la collection, le gabarit disparaît,
     l'attribut est retiré et le bloc se rallume tout seul.
     ------------------------------------------------------------------------ */
  function marquerVides(selecteur, temoin) {
    var blocs = document.querySelectorAll(selecteur);
    for (var i = 0; i < blocs.length; i++) {
      if (blocs[i].querySelector(temoin)) {
        blocs[i].removeAttribute('data-ezl-vide');
      } else {
        blocs[i].setAttribute('data-ezl-vide', '');
      }
    }
  }

  function selectionVide() {
    /* la fiche de démonstration porte le gabarit SVG : sa présence = pas de
       vrai produit. On inverse donc le témoin par rapport aux catégories. */
    var blocs = document.querySelectorAll('.hdt-widget-featured-products');
    for (var i = 0; i < blocs.length; i++) {
      if (blocs[i].querySelector('.hdt-placeholder-svg')) {
        blocs[i].setAttribute('data-ezl-vide', '');
      } else {
        blocs[i].removeAttribute('data-ezl-vide');
      }
    }
    marquerVides('.hdt-widget-categories', '.hdt-categories-list a');
  }


  /* ------------------------------------------------------------------------
     BARRE LATÉRALE — WhatsApp avec les autres réseaux.

     Kalles ne connaît pas WhatsApp : son bloc « social » ne sait afficher que
     facebook, instagram, pinterest, snapchat, tiktok, tumblr, vimeo, x et
     youtube. Or notre pied de page en montre QUATRE, WhatsApp compris : la
     barre latérale doit dire la même chose.

     On ne réécrit rien et on ne recopie AUCUN numéro : on va chercher le lien
     WhatsApp déjà présent dans notre pied de page et on en pose une copie dans
     la liste. Un seul numéro dans tout le thème — si tu le changes dans le
     pied de page, la barre suit toute seule.

     La copie reçoit les classes de Kalles, donc notre pastille ronde s'y
     applique sans une ligne de CSS en plus.
     ------------------------------------------------------------------------ */
  function whatsappBarre() {
    /* Le pied de page contient l'icône WhatsApp (`.foot__social`). Attention :
       la page porte aussi un lien wa.me SANS icône (le bloc « engagements ») —
       on l'écarte en exigeant un <svg> à l'intérieur. */
    var source = null;
    var candidats = document.querySelectorAll('.foot__social a[href*="wa.me"], footer a[href*="wa.me"]');
    for (var c = 0; c < candidats.length; c++) {
      if (candidats[c].querySelector('svg')) { source = candidats[c]; break; }
    }
    if (!source) return;

    var listes = document.querySelectorAll('.hdt-main-sidebar-inner .hdt-socials__list');
    for (var i = 0; i < listes.length; i++) {
      var liste = listes[i];
      if (liste.querySelector('[data-ezl-whatsapp]')) continue;   /* déjà posé */

      var modele = liste.querySelector('.hdt-socials__item');
      if (!modele) continue;

      var item = document.createElement('li');
      item.className = modele.className;
      item.setAttribute('data-ezl-whatsapp', '');

      var lien = document.createElement('a');
      lien.href = source.getAttribute('href');
      lien.target = '_blank';
      lien.rel = 'noopener';
      lien.setAttribute('aria-label', 'WhatsApp');
      lien.className = 'hdt-social-whatsapp hdt-flex hdt-align-center hdt-justify-center';
      lien.innerHTML = source.innerHTML;

      item.appendChild(lien);
      liste.appendChild(item);
    }
  }

  /* ------------------------------------------------------------------------
     LA ROULETTE DOIT DEFILER DANS LES RESULTATS — ORDINATEUR UNIQUEMENT.

     Sur l'accueil, `ezl-home.js` fait tourner Lenis avec `smoothWheel: true` :
     il intercepte la molette pour toute la page. Quand le curseur est au-dessus
     du panneau de recherche, sans repere Lenis fait defiler la PAGE derriere au
     lieu de la liste.

     `data-lenis-prevent` est l'attribut prevu par Lenis exactement pour ca :
     « ici, laisse defiler normalement ». On ne touche a rien d'autre.

     Uniquement au-dessus de 1150 px, comme demande. En dessous ca ne servirait
     de toute facon a rien : Lenis n'est configure que pour la molette, le doigt
     reste natif (pas de `smoothTouch`).
     ------------------------------------------------------------------------ */
  function moletteDansResultats() {
    try {
      if (!window.matchMedia || !window.matchMedia('(min-width: 1150px)').matches) return;
      var panneaux = document.querySelectorAll(
        '.hdt-site-nav_search .hdt-cart-show-has-results,' +
        '.hdt-site-nav_search .hdt-search-suggests-results'
      );
      for (var i = 0; i < panneaux.length; i++) {
        if (!panneaux[i].hasAttribute('data-lenis-prevent')) {
          panneaux[i].setAttribute('data-lenis-prevent', '');
        }
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------------------
     LE DOIGT DOIT DEFILER DANS LES TIROIRS — TELEPHONE COMPRIS.

     Lados : « sur le telephone, sur l'accueil, j'ouvre la recherche, j'ecris un
     produit, je veux faire defiler pour voir ceux du dessous et ca ne defile
     pas. Ca ne defile que sur les autres pages. »

     REPRODUIT ET MESURE le 30 aout, 375 px, accueil, tiroir de recherche
     ouvert, « bebe » tape :
         contenu de la liste   2375 px
         hauteur visible        761 px
         touchmove sans repere  ANNULE   -> le doigt ne fait rien
         touchmove avec repere  passe    -> ca defile

     LA CAUSE. Quand Kalles ouvre un tiroir il bloque la page (`scroll-lock`).
     `ezl-home.js` met alors Lenis EN PAUSE — c'est juste. Mais Lenis en pause
     n'arrete pas d'ecouter. Dans son code :

         element.addEventListener("touchmove", onTouchMove, {passive:false})
         ...
         if (trouve "data-lenis-prevent" dans le chemin) return;
         if (this.isStopped || this.isLocked) { event.preventDefault(); return; }

     Il accroche `touchstart` / `touchmove` / `touchend` SANS CONDITION — pas
     seulement la molette — et en pause il annule chacun d'eux. Sur les autres
     pages Lenis n'existe pas, donc le doigt marche : c'est exactement la
     difference que Lados decrivait.

     CORRECTION D'UNE ERREUR A MOI : j'avais ecrit la veille que Lenis ne
     touchait que la molette et j'avais limite la protection au-dessus de
     1150 px. C'etait faux, et c'etait l'inverse de la ou elle servait.

     ICI : aucune limite de largeur, c'est sur telephone que ca compte. Et on
     vise les TIROIRS (`.hdt-dialog-drawer__inner`), pas le panneau de l'entete :
     celui-la n'a pas besoin de ce repere, la page n'est pas verrouillee quand
     il s'ouvre et le doigt passe deja tout seul.

     Concerne les 7 tiroirs de Kalles : recherche, panier, menu, comparer,
     connexion, inscription. Aucun fichier de Kalles n'est modifie.
     ------------------------------------------------------------------------ */
  function doigtDansLesTiroirs() {
    try {
      var tiroirs = document.querySelectorAll('.hdt-dialog-drawer__inner');
      for (var i = 0; i < tiroirs.length; i++) {
        if (!tiroirs[i].hasAttribute('data-lenis-prevent')) {
          tiroirs[i].setAttribute('data-lenis-prevent', '');
        }
      }
    } catch (e) {}
  }

  /* --------------------------------------------------------------------
     Les pastilles de couleur des fiches : rebrancher le CLIC sur ordinateur

     Kalles branche la pastille sur « mouseenter » dès que l'appareil a un
     survol et n'est pas mobile ; le clic n'est branché QUE sur mobile.
     Sur ordinateur, cliquer une couleur ne fait donc rien : ni l'image, ni
     la variante, ni le prix ne bougent. Mesuré : à 1440 px rien ne change ;
     à 904 px Kalles se croit sur mobile et tout fonctionne.

     On rebranche le clic sur la méthode de Kalles elle-même (handleClick) :
     aucune logique recopiée, aucun fichier d'origine touché.

     Délégation sur le document, pas un écouteur par pastille : Kalles
     réécrit les pastilles à chaque changement de couleur, et un écouteur
     posé sur l'élément disparaîtrait avec lui.

     Là où Kalles écoute déjà le clic (mobile), sa méthode se rejoue à
     l'identique — elle retire puis remet la même classe « active », et son
     appel réseau est déjà retardé de 150 ms : un double appel ne change rien.
     -------------------------------------------------------------------- */
  function clicPastilles() {
    if (document.__ezlPastilles) return;
    document.__ezlPastilles = true;
    document.addEventListener('click', function (ev) {
      var cible = ev.target;
      if (!cible || !cible.closest) return;
      var pastille = cible.closest('hdt-swatch-card');
      if (!pastille) return;
      /* uniquement les fiches produit ; la page produit a son propre sélecteur */
      if (!pastille.closest('hdt-card-product')) return;
      var fiche = pastille.closest('hdt-card-product');
      /* 1) l'image tout de suite, sans attendre le réseau.
            rebuildImage([], fiche) est la méthode que Kalles appelle lui-même
            au survol : elle prend l'image dans « data-vimg » de la pastille. */
      try {
        if (typeof pastille.rebuildImage === 'function') pastille.rebuildImage([], fiche);
      } catch (e) {}
      /* 2) puis la variante, le prix et la classe « active ». */
      try {
        if (typeof pastille.handleClick === 'function') pastille.handleClick();
      } catch (e) {}
      /* 3) filet : si après la réponse l'image n'est toujours pas celle de la
            pastille, on la pose. Kalles garde en mémoire la dernière image
            (_currentImageSrc) et ne repeint pas si elle lui semble identique. */
      var voulue = (pastille.getAttribute('data-vimg') || '').split('/').pop().split('?')[0];
      if (!voulue || !fiche) return;
      setTimeout(function () {
        var img = fiche.querySelector('img.hdt-card-product__media--main');
        if (!img) return;
        var actuelle = (img.getAttribute('src') || '').split('/').pop().split('?')[0];
        if (actuelle === voulue) return;
        var src = (pastille.getAttribute('data-vimg') || '').replace(/[?&]width=\d+/g, '');
        img.setAttribute('src', src);
        img.removeAttribute('srcset');
        fiche._currentImageSrc = src;
      }, 900);
    });
  }

  /* ------------------------------------------------------------------------
     RANGÉE DU HAUT DES COLLECTIONS — la page où l'on est reste en vue.

     Depuis le 3 octobre, la rangée « Top list collections » de Kalles lit la
     liste de chaque collection dans ses métachamps : un monde montre ses
     sous-catégories, une sous-catégorie montre ses voisines. Kalles pose bien
     la classe `hdt-current-active` sur la case de la page où l'on se trouve,
     mais son carrousel démarre TOUJOURS sur la première case : sur
     « Porte-bébés & Écharpes » (9e de Bébé), la case de la page restait hors
     de l'écran, au téléphone comme à l'ordinateur.

     On la fait venir avec la méthode publique du carrousel de Kalles
     (`goToTarget`, sans animation) et on l'annonce aux lecteurs d'écran
     (`aria-current`). Sa couleur est dans `ezl-skin.css`. Aucun fichier de
     Kalles n'est modifié.

     4 octobre — Lados : « à l'ouverture, les cases arrivent de la gauche puis
     vont au milieu, et les flèches apparaissent puis disparaissent ». Le soir :
     « elles sortent encore de la gauche et reviennent au milieu, vite, parfois
     deux fois ». Mesuré image par image : `ezl-skin.css` arrive par le pied de
     page, après la rangée, et le carrousel de Kalles ne finit qu'à son
     événement « init », envoyé un instant APRÈS son démarrage (setTimeout
     d'Embla) — notre ancien signal (customElements.whenDefined) arrivait avant.
     Désormais :
     - la règle qui cache la rangée est dans le <head> (layout/theme.liquid,
       « ezl-rangee-anti-eclair ») : elle vaut dès le premier dessin ;
     - on attend l'événement `init:slide` que Kalles envoie sur sa rangée (son
       premier « init » ou « reInit ») : le carrousel est mesuré, Kalles a
       décidé du centrage et des flèches ;
     - si les polices se chargent encore, on les attend (1,5 s au plus), sinon
       la rangée bougerait à leur arrivée ;
     - puis, dans la même image : la case de la page en vue (`goToTarget`, sans
       animation) et `ezl-fila-pronta` → le CSS montre la rangée, à sa place.
     Filets : si le carrousel ne démarre jamais, la rangée apparaît 2,5 s après
     le chargement ; si ce script ne démarre pas, le <head> la montre après 8 s ;
     sans JavaScript elle n'est jamais cachée.
     ------------------------------------------------------------------------ */
  function rangeePrete(rangee) {
    if (rangee.classList.contains('ezl-fila-pronta')) return;
    var active = rangee.querySelector('.hdt-slider__slide.hdt-current-active');
    if (active) {
      var lien = active.querySelector('a');
      if (lien) lien.setAttribute('aria-current', 'page');
      try { rangee.goToTarget(active, true); } catch (e) {}
    }
    /* la rangée est à sa place : le CSS la montre, flèches comprises */
    rangee.classList.add('ezl-fila-pronta');
  }

  /* Kalles a-t-il déjà démarré cette rangée (script arrivé tard, éditeur) ? */
  function rangeeDemarree(rangee) {
    return rangee.classList.contains('is--enabled') ||
      rangee.classList.contains('hdt-hidden-slider-nav') ||
      !!rangee.querySelector('.hdt-slider__button:not([disabled])');
  }

  function attendreRangee(rangee) {
    if (rangee.classList.contains('ezl-fila-pronta') || rangee.ezlAttend) return;
    rangee.ezlAttend = true;
    /* encore cachée : on éteint le filet de 8 s du <head> (sur un téléphone
       lent, il la montrerait avant que Kalles n'ait fini) — c'est nous qui
       attendons, avec notre propre filet plus bas */
    var vue = rangee.querySelector('.hdt-slider__viewport');
    if (vue && getComputedStyle(vue).opacity === '0') rangee.classList.add('ezl-fila-attente');
    var lancee = false;
    function montrer() {
      if (lancee) return;
      lancee = true;
      var polices = document.fonts && document.fonts.status === 'loading' ? document.fonts.ready : null;
      if (!polices) {
        rangeePrete(rangee);
        return;
      }
      var fini = false;
      var go = function () {
        if (fini) return;
        fini = true;
        requestAnimationFrame(function () { rangeePrete(rangee); });
      };
      polices.then(go, go);
      setTimeout(go, 1500);
    }
    if (rangeeDemarree(rangee)) {
      montrer();
      return;
    }
    rangee.addEventListener('init:slide', montrer);
    var filet = function () {
      setTimeout(function () {
        if (lancee) return;
        lancee = true;
        rangeePrete(rangee);
      }, 2500);
    };
    if (document.readyState === 'complete') filet();
    else window.addEventListener('load', filet);
  }

  function rangeeCollections() {
    var rangees = document.querySelectorAll('.hdt-top-list-collections hdt-slider');
    for (var i = 0; i < rangees.length; i++) attendreRangee(rangees[i]);
  }

  /* Tout de suite : ce script est en bas de la page, AVANT les modules de
     Kalles, donc l'écoute est en place avant que le carrousel ne démarre. */
  rangeeCollections();

  /* ------------------------------------------------------------------------
     DESCRIPTION COURTE — « Lire la suite » (4 octobre 2026).

     Lados : « la proposition me plaît, je la veux partout où il y a des
     produits, téléphone et ordinateur ». La fiche produit et l'« Aperçu
     rapide » montrent les premières lignes de la description, puis « Lire la
     suite » : c'est le réglage natif « Read more » du bloc description de
     Kalles (son élément <product-description>). Sa fermeture dès le premier
     dessin et son aspect sont dans assets/ezl-lire-la-suite.css (chargé dans
     le <head>). Ici, quatre choses que Kalles ne fait pas :
     - la dégradée de la dernière ligne prend la couleur du fond (crème sur la
       fiche, blanc dans l'« Aperçu rapide ») ;
     - la hauteur du texte ouvert (--height) est mesurée UNE fois par Kalles :
       en tournant le téléphone ou en rétrécissant la fenêtre, le texte ouvert
       pouvait être coupé. On la tient à jour (ResizeObserver) ;
     - le bouton annonce son état aux lecteurs d'écran (aria-expanded) ;
     - après « Réduire », si le bouton est passé au-dessus de l'écran, on
       revient doucement au début de la description (la page, ou la fenêtre
       de l'« Aperçu rapide » qui défile) : le client ne se retrouve pas
       perdu plus bas.
     L'« Aperçu rapide » arrive après le chargement (AJAX) : un observateur
     prend en charge les descriptions ajoutées plus tard.
     ------------------------------------------------------------------------ */
  function descriptionCourte(bloc) {
    if (!bloc || bloc.ezlLire) return;
    var contenu = bloc.querySelector('[data-content]');
    var texte = bloc.querySelector('.hdt-full-des');
    var bouton = bloc.querySelector('[data-button]');
    if (!contenu || !texte || !bouton) return;
    bloc.ezlLire = true;
    if (!contenu.id) contenu.id = 'ezl-desc-' + Math.random().toString(36).slice(2, 9);
    bouton.setAttribute('aria-controls', contenu.id);
    bouton.setAttribute('aria-expanded', bloc.classList.contains('is--less') ? 'true' : 'false');
    /* la couleur du fond sous la description (crème sur la fiche, blanc dans
       l'« Aperçu rapide ») : la dégradée de la dernière ligne la reprend */
    for (var e = bloc.parentElement; e && e !== document.documentElement; e = e.parentElement) {
      var m = (getComputedStyle(e).backgroundColor || '').match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/);
      if (m && (m[4] === undefined || +m[4] > 0.5)) {
        bloc.style.setProperty('--ezl-fond', m[1] + ', ' + m[2] + ', ' + m[3]);
        break;
      }
    }
    var hauteur = function () { contenu.style.setProperty('--height', contenu.scrollHeight + 'px'); };
    if (window.ResizeObserver) new ResizeObserver(hauteur).observe(texte);
    new MutationObserver(function () {
      var ouvert = bloc.classList.contains('is--less');
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      if (ouvert) return;
      setTimeout(function () {
        /* dans l'« Aperçu rapide », c'est la fenêtre qui défile, pas la page */
        var boite = null;
        for (var a = bloc.parentElement; a && a !== document.body; a = a.parentElement) {
          var oy = getComputedStyle(a).overflowY;
          if ((oy === 'auto' || oy === 'scroll') && a.scrollHeight > a.clientHeight + 1) { boite = a; break; }
        }
        if (boite) {
          var hb = boite.getBoundingClientRect().top;
          if (bouton.getBoundingClientRect().top < hb + 8) {
            boite.scrollTo({ top: boite.scrollTop + contenu.getBoundingClientRect().top - hb - 16, behavior: 'smooth' });
          }
          return;
        }
        var tete = document.querySelector('hdt-sticky-header');
        var haut = tete ? Math.max(0, tete.getBoundingClientRect().bottom) : 0;
        if (bouton.getBoundingClientRect().top < haut + 8) {
          var y = window.scrollY + contenu.getBoundingClientRect().top - haut - 16;
          if (window.lenis && window.lenis.scrollTo) window.lenis.scrollTo(y);
          else window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 300);
    }).observe(bloc, { attributes: true, attributeFilter: ['class'] });
  }

  function descriptionsCourtes(racine) {
    var blocs = (racine || document).querySelectorAll('product-description.hdt-main-product-description');
    for (var i = 0; i < blocs.length; i++) descriptionCourte(blocs[i]);
  }

  descriptionsCourtes();
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (changements) {
      for (var i = 0; i < changements.length; i++) {
        var ajouts = changements[i].addedNodes;
        for (var k = 0; k < ajouts.length; k++) {
          var n = ajouts[k];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('product-description.hdt-main-product-description')) descriptionCourte(n);
          else if (n.querySelector && n.querySelector('product-description.hdt-main-product-description')) descriptionsCourtes(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------------
     LE DOIGT DOIT DÉFILER DANS LES FENÊTRES — même cause que les tiroirs
     (voir `doigtDansLesTiroirs` plus haut).

     Lados, 8 octobre 2026 : « l'œil des produits du lookbook s'ouvre, mais
     on ne peut pas descendre ». L'aperçu rapide est une fenêtre de Kalles
     (`dialog`), pas un tiroir, et elle n'existe pas encore quand la page
     démarre : mesuré à 375 px sur l'accueil, Lenis en pause y annulait le
     doigt (touchmove annulé, la fenêtre restait à 0 px).

     Au lieu de chercher les fenêtres au démarrage, on pose le repère
     `data-lenis-prevent` sur la fenêtre ouverte AU MOMENT où le doigt (ou
     la molette) la touche. Notre écoute passe avant celle de Lenis : phase
     de capture sur le document, alors que Lenis écoute sur la fenêtre du
     navigateur, en dernier. Vaut pour toutes les fenêtres de Kalles :
     aperçu rapide, ajout rapide, fiches du lookbook ouvertes en bas de
     l'écran, fenêtres d'annonce. Écouteurs passifs : on ne bloque rien, on
     pose seulement le repère.
     ------------------------------------------------------------------------ */
  function doigtDansLesFenetres() {
    if (document.ezlDoigtFenetres) return;
    document.ezlDoigtFenetres = true;
    var marquer = function (e) {
      var cible = e.target;
      var fenetre = cible && cible.closest ? cible.closest('dialog[open]') : null;
      if (fenetre && !fenetre.hasAttribute('data-lenis-prevent')) {
        fenetre.setAttribute('data-lenis-prevent', '');
      }
    };
    document.addEventListener('touchstart', marquer, { capture: true, passive: true });
    document.addEventListener('wheel', marquer, { capture: true, passive: true });
  }

  /* ------------------------------------------------------------------------
     ACCUEIL, TÉLÉPHONE — la barre sous les rangées qui défilent au doigt.

     « Les plus adorés », « Les plus désirés » et « Les bonnes affaires »
     défilent au doigt sous 520 px (et, depuis le 10 octobre, sous 767 px :
     les catégories de « Toutes nos collections », « Vous aimerez aussi » et
     « Vous payez après » de la fiche) ; sous chaque rangée, la même barre que
     « Nouveautés » (dessinée en fond de la rangée par ezl-home.css) se
     remplit pendant qu'on fait défiler. Jusqu'ici elle ne bougeait que dans
     les navigateurs qui connaissent `animation-timeline` : sur le téléphone
     de Lados elle restait vide (8 octobre 2026). On lui donne donc le
     chiffre nous-mêmes : --p va de 0 (début de la rangée) à 1 (bout).

     Une seule mesure par image (requestAnimationFrame) et un écouteur
     passif : le défilement reste fluide. `Math.abs` : si un jour la page
     s'écrit de droite à gauche (arabe), la rangée part dans l'autre sens.
     ------------------------------------------------------------------------ */
  function barreDeRangee(grille) {
    if (grille.ezlBarre) return;
    grille.ezlBarre = true;
    var prevu = false;
    var maj = function () {
      prevu = false;
      var reste = grille.scrollWidth - grille.clientWidth;
      var p = reste > 1 ? Math.min(1, Math.abs(grille.scrollLeft) / reste) : 0;
      grille.style.setProperty('--p', p.toFixed(4));
      /* rangée qui tient dans l'écran : pas de barre (ezl-skin.css) */
      if (grille.toggleAttribute) grille.toggleAttribute('data-ezl-plein', reste <= 1);
    };
    var demander = function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(maj);
    };
    grille.addEventListener('scroll', demander, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(demander).observe(grille);
    else window.addEventListener('resize', demander);
    demander();
  }

  function barresDesRangees() {
    var grilles = document.querySelectorAll('.ezl-scope .bshop__grid, .ezl-coll .ezl-coll__grille, .ezl-sim .ezl-sim__grille, .ezl-etapes .ezl-etapes__pas');
    for (var i = 0; i < grilles.length; i++) barreDeRangee(grilles[i]);
  }

  /* ------------------------------------------------------------------------
     LOOKBOOK — la photo du produit est déjà là quand on touche le « + ».

     Kalles ne charge la photo de la fiche qu'à l'ouverture (`loading=lazy`
     dans une fenêtre fermée) : sur le téléphone la fiche s'ouvrait vide et
     la photo arrivait après (Lados, 8 octobre 2026 : « les produits sortent
     en retard »). Quand le lookbook approche de l'écran, on demande les
     photos des fiches, à la bonne taille : Kalles n'annonce pas de `sizes`,
     le navigateur prenait la version de 940 px pour une case de 210 px
     (téléphone) ou 260 px (ordinateur).

     Seulement les fiches avec un vrai produit (`pointsLookbook` cache les
     autres avec `hidden`), et une seule fois.
     ------------------------------------------------------------------------ */
  function photosLookbook() {
    var images = document.querySelectorAll('.hdt-lookbook_pin:not([hidden]) img');
    var bouton = document.querySelector('.hdt-pin_btn');
    if (!images.length || !bouton) return;
    var preparer = function () {
      for (var i = 0; i < images.length; i++) {
        var img = images[i];
        if (img.dataset.ezlLook === '1') continue;
        img.dataset.ezlLook = '1';
        img.sizes = '(max-width: 767px) 210px, 260px';
        if (img.classList.contains('hdt-card-product__media--main')) img.loading = 'eager';
      }
    };
    var zone = bouton.closest('.shopify-section') || bouton;
    if (!window.IntersectionObserver) { preparer(); return; }
    var guetteur = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          guetteur.disconnect();
          preparer();
          return;
        }
      }
    }, { rootMargin: '600px 0px' });
    guetteur.observe(zone);
  }

  /* ------------------------------------------------------------------------
     LOOKBOOK, ORDINATEUR — la page ne saute plus quand on clique un « + ».

     À la première ouverture d'une fiche, Kalles l'affiche puis lui donne le
     focus AVANT de la placer à côté du « + » : à ce moment-là elle est encore
     tout en bas de la page (Kalles la range à la fin du <body> sur ordinateur).
     Le navigateur fait donc défiler la page jusqu'en bas, puis Kalles la remet
     en place : un saut d'une image (mesuré : 20 737 → 26 958 → 20 737 px).
     Ce saut montrait le bas de page, et le bas de page fait ouvrir « Avant de
     partir » (8 octobre 2026, Lados : « quand je clique le +, le popup sort »).

     Juste avant le clic de Kalles, on pose la fiche près du « + », avec les
     mêmes propriétés que Kalles (top, left, transform) : le focus ne fait plus
     défiler la page, et Kalles la place ensuite exactement comme avant.
     Sur téléphone rien ne change : la fiche s'ouvre en bas de l'écran, sans saut.
     ------------------------------------------------------------------------ */
  function fichesSansSaut() {
    if (document.ezlFichesSansSaut) return;
    document.ezlFichesSansSaut = true;
    document.addEventListener('click', function (e) {
      var bouton = e.target && e.target.closest ? e.target.closest('.hdt-pin_btn[aria-controls]') : null;
      if (!bouton) return;
      var fiche = document.getElementById(bouton.getAttribute('aria-controls'));
      var cadre = fiche ? fiche.parentElement : null;
      if (!fiche || fiche.open || !cadre || cadre.tagName !== 'HDT-POPOVER') return;
      if (cadre.parentElement !== document.body) return;          /* fiche restée dans le lookbook : pas de saut */
      if ((fiche.style.transform || '').indexOf('translate') !== -1) return;   /* déjà placée par Kalles */
      /* un po' più in alto del « + » (la fiche fait ~420 px) : elle est tout entière dans l'écran */
      var r = bouton.getBoundingClientRect();
      var haut = Math.max(window.scrollY + 8, r.top + window.scrollY - 210);
      fiche.style.top = '0';
      fiche.style.left = '0';
      fiche.style.transform = 'translate(' + Math.round(r.left + window.scrollX) + 'px, ' + Math.round(haut) + 'px)';
    }, true);
  }

  /* ------------------------------------------------------------------------
     TIROIR ET PANIER — la corbeille cliquée tout de suite (11 octobre 2026).

     À l'ordinateur, si l'on arrive sur la corbeille et qu'on clique tout de
     suite, la ligne disparaît pendant que Kalles prépare encore l'étiquette
     « Supprimer l'article » (HoverIntent, 80 ms) : Kalles la cherche sur un
     bouton qui n'est plus dans la page et écrit une erreur dans la console
     (TypeError … get arrowEl, global.min.js : code d'origine de Kalles,
     identique au thème Kalles officiel). Kalles saute lui-même l'étiquette
     quand le bouton porte « will-hidden-txt » : on le pose SEULEMENT sur les
     corbeilles qui viennent de quitter la page. Rien ne change à l'écran ;
     les corbeilles présentes gardent leur étiquette.
     ------------------------------------------------------------------------ */
  function cestinoSenzaErrore() {
    if (document.ezlCestino || !window.MutationObserver || !document.body) return;
    document.ezlCestino = true;
    new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        var tolti = lista[i].removedNodes;
        for (var j = 0; j < tolti.length; j++) {
          var n = tolti[j];
          if (n.nodeType !== 1) continue;
          var cestini = n.matches('wrapp-remove-item-oncart') ? [n] : n.querySelectorAll('wrapp-remove-item-oncart');
          for (var k = 0; k < cestini.length; k++) {
            if (!cestini[k].isConnected) cestini[k].setAttribute('will-hidden-txt', '');
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function demarrer() {
    nettete();
    echap();
    declencheurs();
    moletteDansResultats();
    doigtDansLesTiroirs();
    doigtDansLesFenetres();
    fichesSansSaut();
    clicPastilles();
    cestinoSenzaErrore();
    pointsLookbook();
    photosLookbook();
    barresDesRangees();
    selectionVide();
    whatsappBarre();
    document.addEventListener('shopify:section:load', pointsLookbook);
    document.addEventListener('shopify:section:load', photosLookbook);
    document.addEventListener('shopify:section:load', barresDesRangees);
    document.addEventListener('shopify:section:load', selectionVide);
    document.addEventListener('shopify:section:load', whatsappBarre);
    /* La fenêtre est rendue après le pied de page, et l'éditeur de thème
       recharge les sections à la volée : on repasse à chaque rechargement. */
    document.addEventListener('shopify:section:load', nettete);
    document.addEventListener('shopify:section:load', moletteDansResultats);
    document.addEventListener('shopify:section:load', doigtDansLesTiroirs);
    document.addEventListener('shopify:section:load', rangeeCollections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
